export enum StoreErrorFlagId {
	CONVERSATION_FORBIDDEN = 'conversationForbidden',
	CONVERSATION_HISTORY_LOAD_FAILED = 'conversationHistoryLoadFailed',
	FOLLOW_UP_AGENT_UNAVAILABLE = 'followUpAgentUnavailable',
}

export type ShowStoreErrorFlag = (flagId: StoreErrorFlagId) => void;
